import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from 'react-feather';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Dropdown } from '../../../../components/Dropdown';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { ViesLabel } from '../../../Companies/components/ViesLabel';
import { Checkbox } from '../../../../components/Checkbox';
import { Plus } from '../../../../components/Icon';
import { IbanField } from '../../../Companies/components/IbanField';
import { SearchCompanyAndUser } from '../../../Users/components/SearchCompanyAndUser';
import { checkVies, setNewCompanyValue, fetchCompany } from '../../../Companies/actions';
import { WithInstallationClient } from '../../../../components/WithInstallationClient/WithInstallationClient';
import { fetchUser, fetchUsersList } from '../../../Users/actions';
import { selectCompany, selectCountries, selectNewCompany, selectHomeCompany } from '../../../Companies/selectors';
import { selectUsers } from '../../../Users/selectors';
import { selectWorks, selectWork, selectConfig, selectUserId } from '../../../Api/selectors';
import { selectAddressTypes } from '../../../Address/selectors';
import Select from 'react-select';
import { parseUser } from '../../../Users/helpers';
import { getPropByName } from '../../../../utils/props';
import { normalizeSearchString } from '../../../../utils/normalizeSearchString';
import { BTW_COUNTRIES, REQUEST_COMPANY, REQUEST_VIES_CHECK } from '../../../Companies/constants';
import { REQUEST_USER } from '../../../Users/constants';
import { CompanyKYCDocuments } from './ModalDocuments';
import { WIENTJES_INSTALATION } from '../../../../containers/App/constants';
import { formatedDateNow } from '../../../Companies/helpers';
import { property } from 'lodash';
import { makeSelectLocale } from '../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../../Companies/translate-countries';

const Container = styled.div`
  width: 100%;

  .field-block {
    white-space: nowrap;
    margin-bottom: 8px;
    .label {
      width: 60%;
    }
  }

  .radio-label {
    margin: 0 10px;
    font-size: 14px;
  }

  .rounded {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: not-allowed;
  }
  .react-select-container {
    min-width: 300px;
    max-width: 300px;
  }

  .icon-button {
    margin: 0 10px;
  }

  .row-inputs-block {
    .col-1 {
      flex-basis: 20%;
    }
    .col-2 {
      flex-basis: 75%;
    }
  }
  .dropdown-BTW {
    > .Dropdown-root {
      min-width: 50px;
      max-width: 50px;

      > .Dropdown-menu {
        min-width: 130px;
      }
    }
  }
`;

const InputCardWrapper = styled.div`
  .input-card-wrapper {
    > .form-controlField .decorated input {
      min-width: 300px;
    }
    > .decorated {
      border: ${props => (props.isRequired ? '1px solid red' : '')};
    }
    > .form-controlField input {
      border: ${props => (props.isRequired ? '1px solid red' : '')};
    }
  }
`;

const SelectUserWrapper = styled.div`
  .react-select-container {
    min-width: 250px;
    max-width: 250px;

    .react-select__control {
      border-color: ${props => (props.isRequired ? 'red' : '')};
    }
  }
`;

const STATE = {
  string: null,
  result: null,
  address: {},
};

/* eslint-disable react/prefer-stateless-function */
class CompanyKYCModalBaseComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.homeAddress && this.setState({ address: this.homeAddress });
    if (this.props.values?.relation_financial_contact_id) {
      this.props.fetchNewUser(this.props.values?.relation_financial_contact_id, result => {
        this.setState({ result: [parseUser(result)] });
        this.props.setValue(this.props.values?.relation_financial_contact_id, 'relation_financial_contact_id');
      });
      return;
    }
    if (this.props.values?.relation_financial_contact_id) {
      this.props.fetchNewUser(this.props.values?.relation_financial_contact_id, result =>
        this.setState({ result: [parseUser(result)] }),
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.values?.relation_financial_contact_id &&
      prevProps.values?.relation_financial_contact_id != this.props.values?.relation_financial_contact_id
    ) {
      const isAddedUser = this.state.result?.find(u => u.id == this.props.values?.relation_financial_contact_id);
      if (!isAddedUser) {
        this.props.fetchNewUser(this.props.values?.relation_financial_contact_id, result =>
          this.setState({ result: [parseUser(result)] }),
        );
      }
    }
    this.getAddressValues();
  }

  get company() {
    return this.props.company;
  }

  get locale() {
    this.props.locale;
  }

  get homeAddress() {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    return this.company?.addresses.filter(a => a.typeId == addressTypeId)[0];
  }

  getAddressValues() {
    const addressProps = { addressLine1: '', postcode: '', city: '', countryId: '' };
    for (let i in addressProps) {
      if (!this.props.values[i] && this.state.address[i]) {
        this.props.setValue(this.state.address[i], i);
        return this.setState((prev, props) => {
          return { ...prev, address: { ...prev.address, [`${i}`]: null } };
        });
      }
    }
  }

  get filterCompanyId() {
    return this.props.filter?.companyId;
  }

  get btwNumberInputValue() {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.values?.BTW_number?.includes(o.value));
    if (isWithCode) {
      return this.props.values?.BTW_number?.substring(2) || '';
    }
    return this.props.values?.BTW_number;
  }

  onBtwNumberChange(evt, property) {
    {
      let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
      const isWithCode = options.find(o => this.props.values[property]?.includes(o.value));

      if (isWithCode?.value) {
        this.props.setValue(`${isWithCode?.value}${evt.target.value}`, property);
        return;
      }

      this.props.setValue(evt.target.value, property);
    }
  }

  onStringChange(evt) {
    let string = evt;
    this.setState({ string });
    this._t = this.timeout(this.search.bind(this), 300, this._t);
  }

  search() {
    const search = this.state.string?.toLowerCase();
    this.props.fetchUsers(0, undefined, search, this.filterCompanyId, result =>
      this.setState({
        result: result.items?.map(parseUser).filter(user => user.id !== this.props.user?.id),
      }),
    );
  }

  radioButtons(property) {
    return (
      <HBox left>
        <Checkbox checked={this.props.values?.company_type == 'individual'} className="rounded" rounded>
          <strong className="radio-label">{this.lbl('company.property.company_type.individual')}</strong>
        </Checkbox>

        <Checkbox className="rounded" checked={this.props.values?.company_type == 'company'} rounded>
          <strong className="radio-label">{this.lbl('company.property.company_type.company')}</strong>
        </Checkbox>
      </HBox>
    );
  }

  btwDropdown(property) {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    let value = options.find(o => this.props.values[property]?.includes(o.value));

    return (
      <div className={'dropdown-BTW'}>
        <Dropdown
          options={options}
          value={value?.value ? value?.value + ' ' : ''}
          onChange={pair => {
            if (value?.value) {
              this.props.setValue(`${pair.value}${this.props.values?.BTW_number?.substring(2) || ''}`, 'BTW_number');
              return;
            }
            return this.props.setValue(`${pair.value}${this.props.values?.BTW_number || ''}`, 'BTW_number');
          }}
        />
      </div>
    );
  }

  searchSelect() {
    const options = this.props.countries?.map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }));
    const value = options.find(o => o.value == this.props.values?.countryId);

    return (
      <SelectUserWrapper isRequired={!this.props.values?.countryId}>
        <Select
          {...this.props}
          options={options}
          value={this.props.values?.countryId ? value : this.state.address?.country?.id}
          onChange={evt => this.props.setValue(evt.value, 'countryId')}
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </SelectUserWrapper>
    );
  }

  userSelection() {
    const options = this.state.result?.map(user => ({
      value: user.id,
      label: `${user.name || ''} ${user.surname || ''} ${user.email_address || ''}`,
    }));
    const value = options?.find(o => o.value == this.props.values?.relation_financial_contact_id);
    return (
      <SelectUserWrapper isRequired={!this.props.values?.relation_financial_contact_id}>
        <Select
          options={options}
          value={value}
          onChange={evt => {
            // this.props.setValue(evt.value, 'contact');
            this.props.setValue(evt.value, 'relation_financial_contact_id');
          }}
          onInputChange={this.onStringChange.bind(this)}
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </SelectUserWrapper>
    );
  }

  onViesCheck(event) {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.values?.BTW_number?.includes(o.value));
    let dto = {};
    if (isWithCode?.value) {
      dto = {
        id: this.company?.id,
        entity: 'company',
        countryCode: isWithCode?.value,
        vatCode: this.props.values?.BTW_number?.substring(2),
      };
      return this.props.checkViesStatus(dto, result => {
        this.setState({ loading: true });
        this.props.fetchCompany(res => {
          if (res?.id) {
            this.setState({
              loading: false,
            });
          }
        });
      });
    }
    return;
  }

  renderLocationQuestion() {
    return (
      <WithInstallationClient appClientId={WIENTJES_INSTALATION.APP_CLIENT_ID}>
        <VBox left>
          <strong>{this.lbl('vies.vies_check.location.question')}</strong>
          <HBox left>
            {' '}
            <Button
              primary={this.props.values?.vies_location_check == '1'}
              select={this.props.values?.vies_location_check != '1'}
              small
              onClick={() => this.props.setValue('1', 'vies_location_check')}
            >
              {this.lbl('yes')}
            </Button>
            <Button
              primary={this.props.values?.vies_location_check == '0'}
              select={this.props.values?.vies_location_check != '0'}
              small
              onClick={() => this.props.setValue('0', 'vies_location_check')}
            >
              {this.lbl('no')}
            </Button>
          </HBox>
        </VBox>

        {this.props.values?.vies_location_check === '0' && (
          <HBox>
            <CompanyKYCDocuments
              board_id={this.props.board_id}
              column={this.props.column}
              documents={['screenshot_registered_address']}
              locationScreen
              company={this.props.company}
            />
          </HBox>
        )}
      </WithInstallationClient>
    );
  }

  onTradeRegisterCheck(answer) {
    const checkDate = formatedDateNow();
    const userId = this.props.loggedInUser;

    const value = {
      checkDate: checkDate,
      userId: userId,
      value: answer,
    };

    this.props.setValue(JSON.stringify(value), 'trade_register_check');
    this.props.setValue(answer, 'trade_register_check_ok');
    this.setState({ isTradeRegister: answer });
  }

  renderNewFieldsSection() {
    if (!this.props.newFields?.length) return;
    return (
      <>
        <h2 style={{ marginBottom: '20px' }}>{this.lbl('kanban.company_boards.modal.owner_data')}</h2>
        {this.props.newFields?.map(property => {
          return (
            <HBox key={property} vCenter className={'field-block'}>
              <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
              <FormField>
                <Input
                  value={this.props.values[property]}
                  onChange={evt => this.props.setValue(evt.target.value, property)}
                  style={{ minWidth: '300px', border: !this.props.values[property] && '1px solid red' }}
                />
              </FormField>
            </HBox>
          );
        })}
      </>
    );
  }

  save() {
    this.props.onSave();
  }

  reset() {
    this.props.onCancel();
  }

  render() {
    return (
      <Container>
        {this.props.fields?.map(property => {
          if (property == 'company_type') {
            return (
              <HBox key={property} vCenter className={'field-block'}>
                <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                <FormField>{this.radioButtons(property)}</FormField>
              </HBox>
            );
          }

          if (property == 'country_code') return;
          if (property == 'contact') return;

          if (property == 'BTW_number') {
            return (
              this.props.values?.company_type == 'company' && (
                <VBox key={property}>
                  <HBox vCenter className={'field-block'}>
                    <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                    <HBox style={{ minWidth: '300px' }}>
                      <div style={{ width: '100px' }}>{this.btwDropdown(property)}</div>
                      <FormField>
                        <Input
                          value={this.btwNumberInputValue}
                          onChange={evt => this.onBtwNumberChange(evt, property)}
                          style={{ maxWidth: '250px', border: !this.btwNumberInputValue && '1px solid red' }}
                        />
                      </FormField>
                      <div style={{ margin: '-6px' }}>
                        <Button small disabled={this.props.viesWork} onClick={() => this.onViesCheck()}>
                          {this.props.viesWork ? <Loader small /> : 'Check'}
                        </Button>
                      </div>
                    </HBox>
                  </HBox>
                  <HBox vCenter className={'field-block'}>
                    <strong className={'label'}>Vies check</strong>
                    {this.props.viesWork || this.state.loading ? (
                      <div style={{ minWidth: '300px' }}>
                        <Loader small />
                      </div>
                    ) : (
                      <VBox style={{ minWidth: '300px' }}>
                        <ViesLabel vies={getPropByName(this.props.updatedCompany, 'viesCheckStatus')} />
                        {getPropByName(this.props.updatedCompany, 'viesCheckStatus')
                          ? getPropByName(this.props.updatedCompany, 'viesCheckDate')
                          : ''}
                      </VBox>
                    )}
                  </HBox>
                  {this.renderLocationQuestion()}
                </VBox>
              )
            );
          }

          if (property == 'countryId') {
            return (
              <HBox key={property} vCenter className={'field-block'}>
                <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                <FormField>{this.searchSelect()}</FormField>
              </HBox>
            );
          }

          if (property == 'IBAN') {
            return (
              <HBox key={property} vCenter className={'field-block'}>
                <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                <FormField>
                  <InputCardWrapper isRequired={!this.props.values?.IBAN}>
                    <VBox vCenter className="input-card-wrapper">
                      <IbanField
                        ibanApprovedManual={this.props?.values?.IBAN_approved_manual}
                        setIban={(value, approveManual) => {
                          this.props.setValue(value?.replace(/\s/g, ''), 'IBAN');
                          if (approveManual) {
                            this.props.setValue('1', 'IBAN_approved');
                            this.props.setValue('1', 'IBAN_approved_manual');
                          }
                        }}
                        kanbanPage
                        small
                        cardWidth={{ maxWidth: '250px' }}
                        className="input-card-wrapper"
                        company={this.company}
                        key={'IBAN'}
                        value={this.props.values[property]}
                        type={'IBAN'}
                      />
                      <Checkbox checked={this.props?.values?.IBAN_approved_manual == '1'}>
                        {this.lbl('company.iban.checked_manual')}
                      </Checkbox>
                    </VBox>
                  </InputCardWrapper>
                </FormField>
              </HBox>
            );
          }

          if (property == 'accountManagerId') {
            return (
              <HBox key={property} vCenter className={'field-block'}>
                <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                <HBox left>
                  <SearchCompanyAndUser
                    homeCompanyId={this.props.homeCompanyId}
                    key={`${property}-${this.props.values[property]}`}
                    type={property}
                    value={this.props.values[property]}
                    onSelect={value => this.props.setValue(value?.id, property)}
                  />
                </HBox>
              </HBox>
            );
          }

          if (property == 'relation_financial_contact_id') {
            return (
              this.props.values?.company_type == 'company' && (
                <HBox key={property} vCenter className={'field-block'}>
                  <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                  <HBox left vCenter>
                    {this.props.workUsers ? (
                      <Loader small />
                    ) : (
                      <FormField>
                        {this.userSelection()}{' '}
                        <div className="icon-button">
                          <Button small onClick={() => this.props.onShowUserModal()}>
                            <Plus />
                          </Button>
                        </div>
                      </FormField>
                    )}
                  </HBox>
                </HBox>
              )
            );
          }

          if (property == 'surname') {
            return (
              this.props.values?.company_type == 'individual' && (
                <HBox key={property} vCenter className={'field-block'}>
                  <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                  <FormField>
                    <Input
                      value={this.props.values[property]}
                      onChange={evt => this.props.setValue(evt.target.value, property)}
                      style={{ minWidth: '300px', border: !this.props.values[property] && '1px solid red' }}
                    />
                  </FormField>
                </HBox>
              )
            );
          }
          if (property == 'email') {
            return (
              this.props.values?.company_type == 'individual' && (
                <HBox key={property} vCenter className={'field-block'}>
                  <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                  <FormField>
                    <Input
                      value={this.props.values[property]}
                      onChange={evt => this.props.setValue(evt.target.value, property)}
                      style={{ minWidth: '300px' }}
                    />
                  </FormField>
                </HBox>
              )
            );
          }
          if (property == 'company_email') {
            return (
              this.props.values?.company_type == 'company' && (
                <HBox key={property} vCenter className={'field-block'}>
                  <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                  <FormField>
                    <Input
                      value={this.props.values[property]}
                      onChange={evt => this.props.setValue(evt.target.value, property)}
                      style={{ minWidth: '300px', border: !this.props.values[property] && '1px solid red' }}
                    />
                  </FormField>
                </HBox>
              )
            );
          }
          if (property == 'kvk_number') {
            return (
              this.props.values?.company_type == 'company' && (
                <HBox key={property} vCenter className={'field-block'}>
                  <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                  <FormField>
                    <Input
                      value={this.props.values[property]}
                      onChange={evt => this.props.setValue(evt.target.value, property)}
                      style={{ minWidth: '300px', border: !this.props.values[property] && '1px solid red' }}
                    />
                  </FormField>
                </HBox>
              )
            );
          }

          if (property == 'trade_register_check') {
            return (
              <>
                {this.props.KYC_modal && this.props.isEUCustomer && (
                  <WithInstallationClient appClientId={WIENTJES_INSTALATION.APP_CLIENT_ID} key={property}>
                    <VBox left>
                      <strong>{this.lbl('kanban.company_boards.modal.trade_register_check')}</strong>
                      <HBox left>
                        {' '}
                        <Button
                          primary={this.props.values?.trade_register_check_ok == '1'}
                          select={this.props.values?.trade_register_check_ok != '1'}
                          small
                          onClick={() => this.onTradeRegisterCheck('1')}
                        >
                          {this.lbl('yes')}
                        </Button>
                        <Button
                          primary={this.props.values?.trade_register_check_ok == '0'}
                          select={this.props.values?.trade_register_check_ok != '0'}
                          small
                          onClick={() => this.onTradeRegisterCheck('0')}
                        >
                          {this.lbl('no')}
                        </Button>
                      </HBox>
                    </VBox>
                  </WithInstallationClient>
                )}
              </>
            );
          }

          if (property == 'BIC') {
            return (
              this.props.values?.company_type == 'company' && (
                <HBox key={property} vCenter className={'field-block'}>
                  <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                  <FormField>
                    <Input
                      value={this.props.values[property]}
                      onChange={evt => this.props.setValue(evt.target.value, property)}
                      style={{ minWidth: '300px', border: !this.props.values[property] && '1px solid red' }}
                    />
                  </FormField>
                </HBox>
              )
            );
          }
          if (property == 'phone_number') {
            return (
              this.props.values?.company_type == 'individual' && (
                <HBox key={property} vCenter className={'field-block'}>
                  <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
                  <HBox left className="row-inputs-block">
                    <FormField className="col-1">
                      <Input
                        value={this.props.values?.country_code}
                        onChange={evt => this.props.setValue(evt.target.value, 'country_code')}
                        style={{ minWidth: '50px' }}
                      />
                    </FormField>
                    <FormField className="col-2">
                      <Input
                        value={this.props.values[property]}
                        onChange={evt => this.props.setValue(evt.target.value, property)}
                        style={{ border: !this.props.values[property] && '1px solid red' }}
                      />
                    </FormField>
                  </HBox>
                </HBox>
              )
            );
          }
          return (
            <HBox key={property} vCenter className={'field-block'}>
              <strong className={'label'}>{this.lbl(`company.property.${property}`)}</strong>
              <FormField>
                <Input
                  value={this.props.values[property]}
                  onChange={evt => this.props.setValue(evt.target.value, property)}
                  style={{ minWidth: '300px', border: !this.props.values[property] && '1px solid red' }}
                />
              </FormField>
            </HBox>
          );
        })}
        {this.renderNewFieldsSection()}
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: selectNewCompany(),
    homeCompanyId: selectHomeCompany(),
    countries: selectCountries(),
    users: selectUsers(),
    loggedInUser: selectUserId(),
    addressTypes: selectAddressTypes(),
    viesWork: selectWorks([REQUEST_VIES_CHECK, `${REQUEST_COMPANY}-${ownProps.companyId}`]),
    workUsers: selectWork(REQUEST_USER),
    updatedCompany: selectCompany(ownProps.company?.id),
    config: selectConfig(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewCompanyValue(name, value));
    },
    fetchUsers: (offset, limit, string, companyId, callback) => {
      dispatch(fetchUsersList(offset, limit, string, companyId, callback));
    },
    fetchNewUser(userId, callback) {
      dispatch(fetchUser(userId, callback));
    },
    checkViesStatus(dto, callback) {
      dispatch(checkVies(dto, callback));
    },
    fetchCompany(callback) {
      dispatch(fetchCompany(ownProps.company?.id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyKYCModalBase = compose(withConnect, withRouter)(CompanyKYCModalBaseComp);
